<div class="otp-container">
  <div class="otp-content">
    <div class="brand-header">
      <img src="assets/images/logo.png" class="brand-logo" alt="Ryno logo" />
    </div>

    <div class="otp-card">
      <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="otp-form">
            <h2 class="welcome-text">Enter OTP</h2>
            <p class="sub-text">We have sent an OTP to your registered phone number {{ maskedMobileNumber }}</p>

            <div class="otp-inputs">
                <input id="otp1" type="text" maxlength="1" formControlName="otp1" class="otp-input" (input)="moveToNext($event, 'otp2')" (keydown)="handleOtpBackspace($event, 'otp1')">
                <span class="dash">-</span>
                <input id="otp2" type="text" maxlength="1" formControlName="otp2" class="otp-input" (input)="moveToNext($event, 'otp3')" (keydown)="handleOtpBackspace($event, 'otp2', 'otp1')">
                <span class="dash">-</span>
                <input id="otp3" type="text" maxlength="1" formControlName="otp3" class="otp-input" (input)="moveToNext($event, 'otp4')" (keydown)="handleOtpBackspace($event, 'otp3', 'otp2')">
                <span class="dash">-</span>
                <input id="otp4" type="text" maxlength="1" formControlName="otp4" class="otp-input" (keydown)="handleOtpBackspace($event, 'otp4', 'otp3')">
            </div>

            <p class="timer-text">Code expires in: <span class="time-remaining-text">{{ formattedTime }} (5 minutes)</span></p>

            <button type="submit" class="verify-button" [disabled]="!otpForm.valid" [title]="!otpForm.valid ? 'Please enter a valid OTP' : 'Verify'">
                {{!otpForm.valid ? 'Please enter a valid OTP' : 'Verify'}} <span aria-hidden="true">&#8594;</span>
            </button>

            <div class="resend-otp">
                Didn't receive a code?
                <a
                    (click)="resendOtp()"
                    class="resend-link"
                    [class.resend-link-disabled]="!canResendOtp"
                >
                    {{ canResendOtp ? 'Resend OTP' : 'Resend OTP in ' + resendCooldown + 's' }}
                </a>
            </div>
      </form>
    </div>
  </div>
</div>